// extracted by mini-css-extract-plugin
export default {"nav":"nav_nav__WT8lJ","menu-item":"nav_menu-item__uEm81"};